<style lang="scss" scoped>
.module2 {
  .slide-14 {
    background-image: url(../../../assets/module2/slide14/background.png);
    background-position: center;
    background-size: cover;
    padding-top: 0;
    padding-right: 0;
    display: block;
    .pages {
      padding-top: 0;
    }
    .page-right {
      z-index: 1;
    }

    .heading1,
    .heading2 {
      color: #edad0a;
      font-size: 90px;
      transform: rotate(-5deg);
      transform-origin: 200% 0;
      line-height: 90px;
    }

    .heading2 {
      margin-left: 50px;
    }

    .heading3 {
      font-size: 75px;
      color: #fff;
      transform: none;
      white-space: nowrap;
      display: block;
      margin-top: -50px;
      span {
        margin: 0;
        display: inline;
        transform: none;
      }
    }

    .copy1 {
      margin-top: 100px;
      margin-bottom: 30px;
    }

    .copy2 {
      margin-bottom: 80px;
    }
    .copy3 {
      margin-top: -50px;
      width: 60%;
    }

    .red {
      color: #e30613;
    }
    .number {
      font-size: 70px;
      margin-left: 0;
      &:not(.red) {
        color: white;
      }
    }

    .arm {
      margin-left: 200px;
      margin-top: -100px;
    }

    .speech {
      margin-top: -150px;
    }

    .bubble-text {
      display: flex;
      flex-direction: row;
      align-items: center;
      font-family: "Kookycat-FASTcaps";
      font-weight: 100;

      .number {
        font-size: 330px;
        line-height: 330px;
        padding-top: 0.25em;
      }

      .text {
        > span {
          display: block;
          font-size: 25px;
        }
        .big {
          font-size: 50px;
        }
      }
    }
  }
}
</style>

<template>
  <div class="slide-14">
    <transition name="fadeUp" appear>
      <img
        v-show="slideIndex == 13"
        src="@/assets/module2/slide14/112_characters@2x.png"
        class="chars delay-4"
    /></transition>
    <img
      v-show="slideIndex == 13"
      src="@/assets/module2/slide14/green_wave@2x.png"
      class="chars delay-1"
    />
    <img
      v-show="slideIndex == 13"
      src="@/assets/module2/slide14/purple_wave@2x.png"
      class="chars delay-2"
    />
    <img
      v-show="slideIndex == 13"
      src="@/assets/module2/slide14/pink_wave@2x.png"
      class="chars delay-3"
    />

    <transition name="fadeRight" appear>
      <img
        v-show="slideIndex == 13"
        src="@/assets/module2/slide14/image_face@2x.png"
        class="chars delay-3"
      />
    </transition>
    <transition name="fadeRight" appear>
      <img
        v-show="slideIndex == 13"
        src="@/assets/module2/slide14/image_arm@2x.png"
        class="chars delay-3"
      />
    </transition>
    <transition name="fadeRight" appear>
      <img
        v-show="slideIndex == 13"
        src="@/assets/module2/slide14/image_speech@2x.png"
        class="chars delay-3"
      />
    </transition>

    <div class="pages">
      <div class="page page-left">
        <transition name="fadeDown" appear>
          <div v-show="slideIndex == 13" class="delay-1">
            <h1 class="heading1" v-html="$t('module2.slide14.heading1')"></h1>
            <h1 class="heading2" v-html="$t('module2.slide14.heading2')"></h1>
          </div>
        </transition>

        <transition name="fadeLeft" appear>
          <div v-show="slideIndex == 13" class="delay-2">
            <p class="copy1" v-html="$t('module2.slide14.copy1')"></p>
            <p class="copy2" v-html="$t('module2.slide14.copy2')"></p>
          </div>
        </transition>
        <transition name="fadeUp" appear>
          <div v-show="slideIndex == 13" class="delay-3">
            <h1 class="heading3">
              {{ $t("module2.slide14.heading3") }}
              <span class="red number">{{
                $t("module2.slide14.heading4")
              }}</span>
            </h1>
          </div>
        </transition>
      </div>

      <div class="page page-right">
        <transition name="scale" appear>
          <div class="bubble-text face delay-1" v-show="slideIndex == 13">
            <div class="number">{{ $t("module2.slide14.bubble1_1") }}</div>
            <div class="text">
              <span>{{ $t("module2.slide14.bubble1_2") }}</span>
              <span class="big">{{ $t("module2.slide14.bubble1_3") }}</span>
              <span>{{ $t("module2.slide14.bubble1_4") }}</span>
              <span>{{ $t("module2.slide14.bubble1_5") }}</span>
              <span>
                <span class="red">{{ $t("module2.slide14.bubble1_6") }}</span>
                {{ $t("module2.slide14.bubble1_7") }}
              </span>
            </div>
          </div>
        </transition>

        <transition name="scale" appear>
          <div class="bubble-text arm delay-1" v-show="slideIndex == 13">
            <div class="number">{{ $t("module2.slide14.bubble2_1") }}</div>
            <div class="text">
              <span>{{ $t("module2.slide14.bubble2_2") }}</span>
              <span>{{ $t("module2.slide14.bubble2_3") }}</span>
              <span>{{ $t("module2.slide14.bubble2_4") }}</span>
              <span>{{ $t("module2.slide14.bubble2_5") }}</span>
              <span>
                {{ $t("module2.slide14.bubble2_6") }}
                <span class="red">
                  {{ $t("module2.slide14.bubble2_7") }}
                </span>
              </span>
              <span class="big">{{ $t("module2.slide14.bubble2_8") }}</span>
            </div>
          </div>
        </transition>

        <transition name="scale" appear>
          <div class="bubble-text speech delay-1" v-show="slideIndex == 13">
            <div class="number">{{ $t("module2.slide14.bubble3_1") }}</div>
            <div class="text">
              <span
                >{{ $t("module2.slide14.bubble3_2") }}
                <span class="red">{{
                  $t("module2.slide14.bubble3_3")
                }}</span></span
              >
              <span>{{ $t("module2.slide14.bubble3_4") }}</span>
              <span>{{ $t("module2.slide14.bubble3_5") }}</span>
              <span>{{ $t("module2.slide14.bubble3_6") }}</span>
              <span class="big">
                {{ $t("module2.slide14.bubble3_7") }}
              </span>
            </div>
          </div>
        </transition>

        <transition name="scale" appear>
          <p class="copy3">{{ $t("module2.slide14.copy3") }}</p>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["slideIndex"]
};
</script>
